import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1783.68,1468.23529 L1468.23529,1783.68 L1468.23529,1468.23529 L1783.68,1468.23529 Z M1242.35294,1129.41176 L1242.35294,1242.35294 L338.823529,1242.35294 L338.823529,1129.41176 L1242.35294,1129.41176 Z M1581.28941,790.588235 L1581.28941,903.529412 L338.823529,903.529412 L338.823529,790.588235 L1581.28941,790.588235 Z M621.176471,0 C714.578824,0 790.588235,76.0094118 790.588235,169.411765 C790.588235,195.501176 784.150588,219.896471 773.647059,242.032941 L773.647059,242.032941 L999.981176,468.254118 L920.018824,548.216471 L693.797647,321.882353 C671.661176,332.385882 647.265882,338.823529 621.176471,338.823529 C527.774118,338.823529 451.764706,262.814118 451.764706,169.411765 C451.764706,76.0094118 527.774118,0 621.176471,0 Z M1016.47059,225.882353 L1016.47059,338.823529 L1807.05882,338.823529 L1807.05882,1355.29412 L1355.29412,1355.29412 L1355.29412,1807.05882 L112.941176,1807.05882 L112.941176,338.823529 L338.823529,338.823529 L338.823529,225.882353 L5.68434189e-14,225.882353 L5.68434189e-14,1920 L1421.47765,1920 C1466.65412,1920 1509.23294,1902.38118 1541.19529,1870.41882 L1870.41882,1541.30824 C1902.38118,1509.23294 1920,1466.65412 1920,1421.47765 L1920,225.882353 L1016.47059,225.882353 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNoteDarkLine = /*#__PURE__*/function (_Component) {
  _inherits(IconNoteDarkLine, _Component);

  var _super = _createSuper(IconNoteDarkLine);

  function IconNoteDarkLine() {
    _classCallCheck(this, IconNoteDarkLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconNoteDarkLine, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNoteDark",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconNoteDarkLine.displayName = "IconNoteDarkLine";
  return IconNoteDarkLine;
}(Component);

IconNoteDarkLine.glyphName = 'note-dark';
IconNoteDarkLine.variant = 'Line';
IconNoteDarkLine.deprecated = true;
IconNoteDarkLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNoteDarkLine;
export { IconNoteDarkLine };